import { DatabaseResourceFallback } from '@/components/form/database-resource-selector/fallback'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import { DbDataFallback } from '@/routes/databases/create-database/form/sections/db-data/fallback'
import { LocationFallback } from '@/routes/databases/create-database/form/sections/location/fallback'
import { NameFallback } from '@/routes/databases/create-database/form/sections/name/fallback'
import { OverviewFallback } from '@/routes/databases/create-database/form/sections/overview/fallback'
import { PaymentMethodFallback } from '@/routes/databases/create-database/form/sections/payment-method/fallback'
import { DatabaseTypeFallback } from '@/routes/databases/create-database/form/sections/type/fallback'

export const CreateDatabaseFallback = () => {
  return (
    <div className="grid gap-4 grid-cols-1 lg:grid-cols-[2fr_1fr]">
      <Card>
        <CardContent className="p-0">
          <H3 className="mb-6 px-6">Database details</H3>
          <div className="space-y-6">
            <div className="space-y-6 px-6">
              <DatabaseTypeFallback />
              <DbDataFallback />
            </div>
            <Separator />
            <div className="space-y-6 px-6">
              <NameFallback />
              <LocationFallback />
              <DatabaseResourceFallback />
              <Skeleton className="h-9 w-40" />
            </div>
          </div>
        </CardContent>
      </Card>
      <div className="flex flex-col gap-4">
        <Card className="hidden lg:block">
          <CardContent>
            <div className="flex flex-col gap-4">
              <H3>Overview</H3>
              <div className="flex flex-col gap-6">
                <OverviewFallback />
              </div>
            </div>
          </CardContent>
        </Card>
        <Card className="hidden lg:block">
          <CardContent>
            <div className="flex flex-col gap-4">
              <H3>Payment method</H3>
              <div className="flex flex-col gap-6">
                <PaymentMethodFallback />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
